import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[appLazyLoad]',
  standalone: true,
})
export class LazyLoadDirective implements OnInit {
  @Input() appLazyLoad: any;

  private hasLoaded = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    setTimeout(() => {
      if (!this.hasLoaded) {
        this.loadContent();
      }
    }, Math.random() * 100);
  }

  private loadContent() {
    this.hasLoaded = true;
    this.viewContainer.createEmbeddedView(this.templateRef, {
      $implicit: this.appLazyLoad,
    });
  }
}
